/**
 * 应用上下文（启动时拉取一次：登录态、文件根地址、今日签到等）
 */
import request from '../xajax'
import type { ApiResponse } from '../interfaces'
import type { FrontUserInfo } from './login'

export interface AppContext {
  code?: string
  openpay?: boolean
  baiduMapAk?: string
  fileBaseUrl?: string
  uploaders?: string[]
  appId?: string
  todaySign?: boolean
  isLogin?: boolean
  user?: FrontUserInfo | null
  niurenBind?: boolean
  niurenName?: string
}

export interface AppVersion {
  /** 是否有新版本，只有请求时带有versionCode请求时，此值才会有意义。 默认false*/
  hasUpdate?: boolean
  /** 是否强制更新，默认false*/
  forceUpdate?: boolean
  /** 最新版本号, 默认0，按此值更新*/
  latestVersionCode?: number
  /** 最新版本名称, 如 1.0.0 默认空字符串 */
  latestVersionName?: string
  /** 更新程序下载地址, 默认空字符串*/
  downloadUrl?: string
  /** 安装包大小（字节），用于下载前提示体积 */
  fileSize?: number
  /** 最小版本号, 默认0*/
  minVersionCode?: number
  /** 更新内容, 默认空字符串*/
  updateContent?: string
  /** 发布时间, 默认空字符串*/
  publishTime?: string
}

export const apiAppContext = {
  getContext: (): Promise<ApiResponse<AppContext>> => request.get('/client/context/init')
}

/** 检查更新的请求参数（后端 GET /client/app/version/check） */
export interface CheckVersionParams {
  /** 应用标识，与后台「系统管理 - 应用版本」里的 appCode 一致 */
  appCode: string
  /** 平台：android / ios / windows …，与后台版本记录的 platform 一致 */
  platform?: string
  /** 当前版本号（整数），用于比大小 */
  versionCode?: number
  /** 当前版本名，如 1.0.0；不带 versionCode 时后端按版本名比对 */
  versionName?: string
}

/**
 * 检查版本更新（免登录接口）。
 *
 * 后端按 appCode + platform 精确匹配「已发布」的那条版本记录，
 * 拿它的 versionCode 和客户端传上来的 versionCode 比大小决定 hasUpdate。
 */
export const checkVersion = (params: CheckVersionParams): Promise<ApiResponse<AppVersion>> =>
  request.get('/client/app/version/check', params)